module.exports = __webpack_public_path__ + "media/images/emblems/Buchrain_LU_border2-318512c4a3834b326dccc16287b961c6.png";